real.history = (function() {
    'use strict';

    return {
        push : function(url) {
            history.pushState(url, '', url);
        },

        back : function() {
            window.history.back();
        },

        replace : function(url) {
            history.replaceState(url, '', url);
        }
    };

})();